<script lang="ts">
	export let src: string;
	export let transparent = false;
	export let size = "8-3_xl";
	export let alt = "";

	const getImageSrc = (): string => {
		if (transparent) {
			return `${src}?bg=rgba(255,0,255,255)&fmt=png&`;
		} else {
			return `${src}?`;
		}
	};

	const imageSrc = getImageSrc();
	const ariaHidden = alt ? "false" : "true";
</script>
<div class="oc-block-v1 oc-p-0 header__image">
	<picture>
		<source
			media="(min-width: 48em)"
			srcset="{imageSrc}$promo_poi_{size}_progressive$&fmt=webp"
			type="image/webp"
		/>
		<source
			media="(min-width: 48em)"
			srcset="{imageSrc}$promo_poi_{size}_progressive$"
		/>
		<img
			aria-hidden={ariaHidden}
			alt={alt}
			src="{imageSrc}$promo_poi_4-3_s_progressive$"
		/>
	</picture>
</div>

<style>
	.header__image img {
      width: 100%;
	}
</style>
